let token = null;

export default {
  buscarDados(vue, id_empresa, stop, callback) {
    vue.$store.state.msgServer = "Carregando os dados..";
    token = localStorage.getItem("key");
    this.buscarVersao(vue, id_empresa, stop, callback);
  },

  buscarVersao(vue, id_empresa, stop, callback) {
    vue.$store.state.msgServer = "Verificando sua versão..";

    let electronV = vue.isElectron ? vue.electronV : null;
    vue.$store.state.version.electronV = electronV;

    vue.$http.get("sistema/versao", { params: { id_empresa, beta: !!vue.is_beta }} )
      .then(res => {
        if (res.data && res.data.gestor_web) {
          const gestor_web = parseInt((res.data.gestor_web || "0").replace(/\D/g, ""));
          vue.$store.state.version.gestor_web = gestor_web;

          const app_electron = parseInt((res.data.app_electron || "0").replace(/\D/g, ""));
          vue.$store.state.version.app_electron = app_electron;
          const gestorId = (window.gPConfigs || {}).gestorId;
          const app_version = parseInt(vue.app_version.replace(/\D/g, ""));

          if (vue.isElectron && gestorId && electronV && vue.app_version) {
            vue.$http.post("v2/sistema/device-gestor", {
              device: gestorId,
              nome_device: ((window.gPConfigs || {}).host || "").slice(0, 100) || null,
              gestor_web: String(app_version),
              app_electron: String(electronV)
            }, { emulateJSON: false }).then(() => {}, () => {});
          }

          if ((gestor_web > app_version) || (electronV && app_electron > electronV)) {
            callback(false);
            return;
          }

          this.buscarConfigs(vue, stop, callback);

        } else {
          vue.$store.state.msgServer = "Erro ao buscar a versão do sistema";
        }

      }, res => {
        vue.$store.state.msgServer = res.data?.msg || "Erro ao buscar a versão do sistema";
      });
  },

  buscarConfigs(vue, stop, callback) {
    token = localStorage.getItem("key");

    if (!vue.$cache.isExpired("configs")) {
      return this.buscarConfigImpressao(vue, stop, callback);
    }

    vue.$http.get("pdv/configs/" + token)
      .then(response => {

        if (response.data) {
          vue.$store.commit("setConfigs", response.data);
          vue.$cache.set("configs", response.data);
        }

        this.buscarConfigImpressao(vue, stop, callback);

      }, res => {
        if (res.status === 401) {
          vue.logout(true);
          vue.$router.push("/");
        } else {
          vue.$store.state.msgServer = res.data?.msg || "Erro ao buscar as configs";
        }
      });
  },

  buscarConfigImpressao(vue, stop, callback) {
    vue.$store.state.msgServer = "Carregando as configurações de impressão..";
    const cache = vue.$cache.get("configImpressao");

    if (cache) {
      vue.$store.commit("setConfigImpressao", cache);
      return this.buscarZonasEntrega(vue, stop, callback);
    }

    vue.$http.get("v2/impressao/config")
      .then((response) => {
        const data = response.data || {};
        const config = data;

        vue.$store.commit("setConfigImpressao", config);
        vue.$cache.set("configImpressao", config);
        this.buscarZonasEntrega(vue, stop, callback);

      }, (res) => {
        vue.$store.state.msgServer = res.data?.msg || "Erro ao carregar as configurações de impressão";
      });
  },

  buscarZonasEntrega(vue, stop, callback) {
    vue.$store.state.msgServer = "Buscando as taxas de entrega..";

    if (!vue.$cache.isExpired("zonas")) {
      return this.buscarFormasPagamento(vue, stop, callback);
    }

    vue.$http.get("entrega/zonas/" + token + "?status=1")
      .then(response => {

        const zonas = (response.data || []).map(z => ({
          ...z,
          texto: `${z.nome_zona} - R$ ${z.taxa_entrega}`,
          id: z.id_zona
        }));

        vue.$store.commit("setZonas", zonas);
        vue.$cache.set("zonas", zonas);

        this.buscarFormasPagamento(vue, stop, callback);

      }, res => {
        vue.$store.state.msgServer = res.data?.msg || "Erro ao buscar as taxas de entrega";
      });
  },

  buscarFormasPagamento(vue, stop, callback) {
    vue.$store.state.msgServer = "Buscando as formas de pagamento..";

    if (!vue.$cache.isExpired("pagamentos")) {
      if (stop) {
        vue.$store.state.msgServer = null;
        callback(true);

      } else {
        this.buscarProdutos(vue, callback);
      }

      return;
    }

    vue.$http.get("pdv/formas-pagamentos/" + token)
      .then(response => {
        vue.$store.commit("setPagamentos", response.data);
        vue.$cache.set("pagamentos", response.data);

        if (stop) {
          vue.$store.state.msgServer = null;
          callback(true);

        } else {
          this.buscarProdutos(vue, callback);
        }

      }, res => {
        vue.$store.state.msgServer = res.data?.msg || "Erro ao buscar as formas de pagamento";
      });
  },

  buscarProdutos(vue, callback) {
    vue.$store.state.msgServer = "Baixando os produtos..";

    if (!vue.$cache.isExpired("produtos")) {
      return this.buscarTermos(vue, callback);
    }

    vue.$http.get("pdv/produtos/" + token)
      .then(res => {

        if (res.data?.produtos && res.data?.categorias) {
          vue.$store.commit("setProdutos", res.data);
          vue.$cache.set("produtos", res.data);
        }

        this.buscarTermos(vue, callback);

      }, res => {
        vue.$store.state.msgServer = res.data?.msg || "Erro ao buscar os produtos";
      });
  },

  buscarTermos(vue, callback) {
    if (!vue.$cache.isExpired("termos")) {
      vue.$store.state.msgServer = null;
      return callback(true);
    }

    vue.$http.get("comandas/termos-rapidos/" + token)
      .then(response => {
        vue.$store.commit("setTermos", response.data);
        vue.$cache.set("termos", response.data);
        vue.$store.state.msgServer = null;
        callback(true);

      }, res => {
        vue.$store.state.msgServer = res.data?.msg || "Erro ao buscar os termos rápidos";
      });
  },

  buscarColaboradores(vue, token) {
    vue.$store.state.load = true;
    const cache = vue.$cache.get("colaboradores");

    if (cache) {
      vue.$store.state.colaboradores = cache;
      vue.$store.state.load = false;
      return;
    }

    vue.$http.get("usuarios/" + token + "/1", { params: { funcoes: ["1","2","3"] } })
      .then(response => {

        if (response.data) {
          const colaboradores = response.data.result || [];
          vue.$store.state.colaboradores = colaboradores;
          vue.$cache.set("colaboradores", colaboradores);
        }

        vue.$store.state.load = false;

      }, res => {
        vue.$store.state.load = false;
        vue.$swal(res.data?.msg || "Erro ao buscar os usuários");
      });
  }
};
